<adapt-dialog [maxWidth]="600">
    <h3 adapt-dialog-title>Import journey progress into organisation</h3>

    <div adapt-dialog-content
         class="d-flex flex-column gap-3">
        @if (!fixedOrganisation) {
            <div>
                <label>Organisation</label>
                <dx-select-box [dataSource]="organisations"
                               [(value)]="organisation"
                               [showClearButton]="false"
                               [searchEnabled]="true"
                               displayExpr="name"></dx-select-box>
            </div>
        }

        <p class="mb-0">
            Imported modules are independent copies. All tasks start as <b>To do</b>, without recorded dates or comments.<br>
            Module names must be unique within this organisation. Rename or delete the existing module before importing another with the
            same name.
        </p>

        <div>
            <adapt-select-progress-products [(progressProductIds)]="productsToAdd"
                                            [organisation]="organisation"></adapt-select-progress-products>
        </div>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [saveIsDisabled]="saveIsDisabled"
                                   [saveBlockingClick]="saveAndClose"
                                   (cancelClick)="cancel()"></adapt-standard-dialog-buttons>
</adapt-dialog>
